import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, resendActivationCode, trackInvite } from "app/redux/auth/authHandler";
import useValidation from "app/common/custom-hooks/useValidation";
import SpinnerButton from "app/common/components/SpinnerButton";
import FormInput from "app/common/components/FormInput";
import { Link } from "react-router-dom";
import useIsLoading from "app/common/custom-hooks/useIsLoading";
import Step2 from "app/pages/auth/_components/_register-steps/Step2";
import useActionListener from "app/common/custom-hooks/useActionListener";
import ConditionalRender from "app/common/components/ConditionalRender";

const Login = _ => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const [otpData, setOtpData] = useState(null);
    const {validation, data} = useValidation(formRef, true);
    const isLoading = useIsLoading("auth");
    const inviteEmail = useSelector(({auth}) => auth.invite?.email);

    // Form Submission process
    const handleSubmit = _ => {
        dispatch(login(data));
    }

    useActionListener("otpRequired", (_, res) => {
        setOtpData(res);
    })

    useActionListener("allow401", (_, __, ___, errorCode) => {
        if (errorCode === 202){
            setOtpData(data);
            dispatch(resendActivationCode(data?.email))
        }
    })

    if (otpData){
        return <Step2 {...{...otpData, isLoading}} />
    }

    return  <div>
                <form onSubmit={handleSubmit} ref={formRef}>
                    <h2
                        className="text-3xl md:text-[2.5rem] md:leading-[3rem] text-black-1 font-semibold pb-2 dark:text-white "
                    >
                        Making commerce as simple as a chat
                    </h2>
                    <p
                        className="pb-12 text-grey-7"
                    >
                        Sign in to continue
                    </p>
                    <div className="">
                        <FormInput
                            label="Email:"
                            type='email' 
                            placeholder="example@mail.com" 
                            required 
                            name="email"
                            validation={validation}
                            invalidMessage="Enter a valid email address"
                            defaultValue={inviteEmail}
                            readOnly={!!inviteEmail}
                            key={`field-${inviteEmail}`}
                        />
                        <FormInput
                            label="Password:"
                            type='password' 
                            placeholder="Enter your password" 
                            required 
                            name="password"
                            validation={validation}
                            invalidMessage="Enter your password"
                            contClass="mt-5"
                            pattern="(.+){4,}"
                            minLength="4" 
                        />
                        <p className="text-smx text-grey-5 mt-1.5 ">
                        Trouble signing in,  <Link to="/reset-password" className="text-primary">
                                Reset Password
                            </Link> 
                        </p>
                        <div className="mt-9 mb-2">
                            <SpinnerButton 
                                type="submit" 
                                disabled={!validation.validated} 
                                className="w-full btn-primary btn-md" 
                                isLoading={isLoading}
                                text="Sign in"
                            />
                        </div>
                        <ConditionalRender
                            render={!!inviteEmail}
                        >
                            <div
                                className="py-8"
                            >
                                <hr />
                                <p className="text-center -mt-2.5">
                                    <span
                                        className="inline-block px-5 bg-white"
                                    >
                                        or
                                    </span>
                                </p>
                            </div>
                            <div className="space-y-5">
                                <button
                                    className="w-full btn-outline btn-md font-medium"
                                    type="button"
                                    onClick={_ => dispatch(trackInvite(null))}
                                >
                                    Sign in to another account
                                </button>
                            </div> 
                        </ConditionalRender>
                        {/* <div className="space-y-5">
                            <button
                                className="w-full btn-outline btn-md font-medium"
                                type="button"
                            >
                                <img
                                    src="/assets/media/image/google.png" alt="G" className="w-4 mr-2 -mt-1 inline"
                                /> Sign in with Google
                            </button>
                        </div> */}
                    </div>
                </form>
            </div>
}

export default Login;